import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-mlse-foundation-tab',
  templateUrl: './mlse-foundation-tab.component.html',
  styleUrls: ['./mlse-foundation-tab.component.scss'],
  imports: [],
  host: {
    'class': 'page',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MlseFoundationTabComponent {}
